$(function () {
    var body = $('body');
    var main = $('main');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('ul li');
    var megamenu_trigger = $('.nav').find('ul li.menu-item-has-megamenu');
    var megamenu_window = $('.Megamenu');
    var megamenu_navlist = $('.megamenu-nav-list');
    var megamenu_parent = $('.megamenu-column-one');
    var megamenu_trigger = $('.menu-item-has-megamenu');
    var break_point = 992;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');
    var browser_width = window.innerWidth;

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (browser_width < break_point) {
                nav_reset();
                burger.focus();
            } else {
                nav_trigger.removeClass('__active');
                megamenu_window.removeClass('__active');
                $('.menu-item-has-megamenu>button').attr('aria-expanded', false);
                main.removeClass('__bg-blur');
            }
        }
    });


    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
            megamenu_window.removeClass('__active');
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul').removeClass('__active');
        megamenu_window.removeClass('__active');
        megamenu_navlist.removeClass('__active');
        megamenu_parent.removeClass('__active');
        main.removeClass('__bg-blur');
        $('.navwrap-logo').addClass('__active');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    function initMenu() {
        browser_width = window.innerWidth;

        // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {

            nav_trigger.focusin(function () {
                $(this).addClass('__active');
                $(this).children('button').attr('aria-expanded', true);
            });
            nav_trigger.focusout(function () {
                $(this).removeClass('__active');
                $(this).children('button').attr('aria-expanded', false);
            });
            nav_trigger.mouseover(function () {
                $(this).children('button').attr('aria-expanded', true);
            });
            nav_trigger.mouseout(function () {
                nav_reset();
            })

            megamenu_trigger.focusin(function () {
                // Disable other megamenus that might be open
                megamenu_trigger.removeClass('__active');
                megamenu_trigger.children('button').attr('aria-expanded', false);;
                megamenu_trigger.children('.Megamenu').removeClass('__active');
                // Disable current megamenu
                $(this).addClass('__active');
                $(this).children('button').attr('aria-expanded', true);
                $(this).children('.Megamenu').addClass('__active');
                main.addClass('__bg-blur');
            });
            megamenu_trigger.mouseover(function () {
                $(this).children('button').attr('aria-expanded', true);
                $(this).children('.Megamenu').addClass('__active');
                main.addClass('__bg-blur');
            });
            megamenu_trigger.mouseout(function () {
                $(this).children('button').attr('aria-expanded', false);
            });
;
            $('li.menu-item-has-megamenu>a, li.menu-item-has-megamenu>button').click(function () {
                if ($(this).children('.Megamenu').hasClass('__active')) {
                    $(this).children('.Megamenu').removeClass('__active');
                    nav_reset();
                }

                else {
                    $(this).children('.Megamenu').addClass('__active');
                    main.addClass('__bg-blur');
                }
            });
        }

        if (browser_width < break_point) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                    $(this).parents('ul').removeClass('__active');
                    $(this).children('ul').addClass('__active');
                    $('.navwrap-logo').removeClass('__active');
                }
                if ($(this).children('.Megamenu').length > 0) {
                    $(this).parents('ul').removeClass('__active');
                    $(this).children('.Megamenu').addClass('__active');
                    $('.megamenu-nav-list').addClass('__active');
                    $('.megamenu-column-one').addClass('__active');
                }
            });

            megamenu_trigger.click(function (event) {
                $('.navwrap-logo').removeClass('__active');
            });
        }

        if (browser_width < break_point) {
            var back_menu = $('.backto');
            back_menu.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this).parent('ul').removeClass('__active');
                $(this).parents('li').parent('ul').addClass('__active');
                $(this).closest(megamenu_window).removeClass('__active');
                $('.megamenu-column-one').removeClass('__active');
                $('.navwrap-logo').addClass('__active');
            });

            var back_menu = $('.backtochild');
            back_menu.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this).parent('ul').removeClass('__active');
                $(this).parents('li').parent('ul').addClass('__active');
                $(this).closest(megamenu_window).removeClass('__active');
                $('.megamenu-column-one').removeClass('__active');
            });

            var back_menu_mega = $('.backtomega');
            back_menu_mega.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this).parent('.megamenuContent').removeClass('__active');
                $(this).closest(megamenu_window).addClass('__active');
                $(megamenu_parent).addClass('__active');
                $(megamenu_trigger).removeClass('__active');
                $('.mobile-menu-title.__main').show();
            });
        }

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }

        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });
        }
    }

    initMenu();

    $(window).on('resize', function () {
        initMenu();
        nav_reset();
        megamenu_window.removeClass('__active');
    });
});

$(function () {
    var break_point = 992;
    var browser_width = window.innerWidth;

    $('.Megamenu').each(function (i, tab) {
        var tabRoot = $(this);
        var tabTrigger = '.megamenuTrigger';
        var tabTriggerMobile = '.megamenuTriggerMobile';
        var tabContent = '.megamenuContent';
        var tabImage = '.megamenuTabImage';
        var findTabTrigger = tabRoot.find(tabTrigger);
        var findTabTriggerMobile = tabRoot.find(tabTriggerMobile);
        var findTabContent = tabRoot.find(tabContent);
        var findTabImage = tabRoot.find(tabImage);

        findTabTrigger.attr('aria-selected', false);
        findTabTriggerMobile.attr('aria-selected', false);
        findTabContent.attr('aria-expanded', false);
        findTabImage.attr('aria-expanded', false);

        findTabTrigger.eq(0).addClass('__active').attr('aria-selected', true);
        findTabTriggerMobile.eq(0).addClass('__active').attr('aria-selected', true);
        findTabContent.eq(0).addClass('__active').attr('aria-expanded', true);
        findTabImage.eq(0).addClass('__active').attr('aria-expanded', true);

        // enable hover on desktop
        if (browser_width >= break_point) {
            findTabTrigger.mouseover(function (e) {
                e.preventDefault();
                var dataSet = $(this).data('set');

                tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
                $(this).attr('aria-selected', true).addClass('__active');

                tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');

                tabRoot.find(tabImage + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabImage + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');

            });
            findTabTrigger.focusin(function (e) {
                e.preventDefault();
                var dataSet = $(this).data('set');

                tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
                $(this).attr('aria-selected', true).addClass('__active');

                tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');

                tabRoot.find(tabImage + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabImage + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');
            });
        }

        else {
            findTabTriggerMobile.click(function (e) {
                var dataSet = $(this).data('set');

                tabRoot.find(tabTriggerMobile + '.__active').attr('aria-selected', false).removeClass('__active');
                $(this).attr('aria-selected', true).addClass('__active');

                tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');

                tabRoot.find(tabImage + '.__active').attr('aria-expanded', false).removeClass('__active');
                tabRoot.find(tabImage + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');
            })
        }

        findTabTrigger.click(function (e) {
            $(tabRoot).addClass('__active');
        });

        // mobile meganav tabs in progress
        if (browser_width < break_point) {
            findTabTriggerMobile.click(function (e) {
                $('.megamenu-column-one').removeClass('__active');
            });
        };

    });
});

